module.exports = __webpack_public_path__ + "42b163a457957f4e4528628f7475a132.MP3";